module.exports = __webpack_public_path__ + "61ff4c89d63eb69987659f8874569267.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/black-and-white-images/B_W2.jpg
// module id = 3302
// module chunks = 0